import { useTranslation } from 'react-i18next';

import { UnitEnum } from '@/api/rest/resources/types/units';
import { Slider } from '@/components/widgets/a/Slider/Slider';
import { useControlsContext } from '@/components/widgets/o/Map/hooks/useFormControls';

import { SectionTitle, SectionWrapper } from './Sections';

export const OpacitySlider = () => {
  const { t } = useTranslation();
  const controlsForm = useControlsContext();
  const opacityValue = controlsForm.watch('layerOpacity');

  const handleOnChange = (value: number) => {
    controlsForm.setValue('layerOpacity', value);
  };

  return (
    <SectionWrapper>
      <SectionTitle text={t('shared.projects.project.mapLayerEditMenu.opacityt.labels.opacity')}></SectionTitle>
      <Slider value={opacityValue} onChange={handleOnChange} showMinMax={true} unit={UnitEnum['%']} />
    </SectionWrapper>
  );
};
